// src/admin/Admin.jsx
import React from "react";
import {Routes, Route, useNavigate} from "react-router-dom";
import "./Admin.css";
import AdminNav from "./AdminNav/AdminNav";
import ProductPage from "./AdminNav/pages/ProductPage";
import RecipesPage from "./AdminNav/pages/recipes";
import ToHomepageBtn from "../Shared/ToHomepageBtn";
import Statistics from "./AdminNav/pages/Statistics";
import {supabase} from "../../supabaseClient";
import FoodItemsPage from "./AdminNav/pages/FoodItemsPage";
import OrdersPage from "./AdminNav/pages/OrdersPage";
import DoneOrdersPage from "./AdminNav/pages/DoneOrders";

function Admin() {
    const navigate = useNavigate();

    const handleLogout = async () => {
        const {error} = await supabase.auth.signOut();
        if (error) {
            console.error("Error logging out:", error.message);
            return;
        }
        navigate("/");
    };
    return (
        <>
            <ToHomepageBtn />
            <div className="admin-container">
                <AdminNav />
                <button onClick={handleLogout} className="logout-button">
                    LOGGA UT
                </button>
                <div className="admin-content">
                    <Routes>
                        <Route path="/recipes-page" element={<RecipesPage />} />
                        <Route path="/food-items" element={<FoodItemsPage />} />
                        <Route path="/product" element={<ProductPage />} />
                        <Route path="/orders" element={<OrdersPage />} />
                        <Route path="/done-orders" element={<DoneOrdersPage />} />
                        <Route path="/statistics" element={<Statistics />} />
                    </Routes>
                </div>
            </div>
        </>
    );
}

export default Admin;
